import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { categoryReviewStore } from './store'

import { KEY } from './constants'

export * from './constants'

export const CategoryReviewModule: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, categoryReviewStore)
}
